import React from 'react';

const HowItStarted: React.FC = () => {
    return (
        <div className="site-page-content">
            <h1>How It All Started</h1>
            <h3>My Journey into Technology</h3>
            <br />
            <div className="text-block">
                <br />
                <p>
                    Ever since I was a kid, I was always curious about how things worked. That led to an obsession with building things whether it was Lego or coding experiments.
                    I still remember joining a Lego Robotics team when I was younger. That was my first taste of programming, and I was hooked.
                </p>
                <br />
                <p>
                    As I grew older, I started coding more seriously. It began with simple web scraping, then turned into full-blown projects. I've worked on all sorts of things robots, games, apps, AI models... just things that seemed cool at the time.
                </p>
                <br />
                <p>
                Fun fact : back in 2015, my parents enrolled me in a programming course. I was technically too young for it, but my dad convinced them to let me in. That course introduced me to C++, my first real programming language. From there, everything changed.
                </p>
                <br />
            </div>
        </div>
    );
};

export default HowItStarted;
